import React from 'react';

export const useTabs = (
	initial = 0
): { activeTab: number; changeTab: (next: number) => void } => {
	const [activeTab, setActiveTab] = React.useState<number>(initial);
	const changeTab = React.useCallback(
		(next: number) => setActiveTab(next),
		[]
	);
	return { activeTab, changeTab };
};
